function formatLevel(level) {
  const text = String(level || '').trim();
  return text ? text.replace(/_/g, ' ') : '';
}

function buildStageDisplay(stage = {}) {
  const drillNames = (stage.drills || []).map((drill) => drill?.name).filter(Boolean);
  return {
    key: stage.stage || '',
    title: stage.title || '',
    drillNames,
    hasDrills: drillNames.length > 0,
    emptyText: 'No drills yet.',
  };
}

// Pass 77 REPAIR (P1 #1) — the presentation must tell the TRUTH about progression state. The canonical no-evidence
// engine returns a NON-NULL recommendation object with hasEvidence=false and null skill/track/level, so
// `Boolean(progressionRecommendation)` is NOT a valid has-recommendation test. Authority is the canonical evidence
// flag (summary.hasProgressionEvidence / progressionInput.hasEvidence). With zero canonical evidence we show an
// honest UNKNOWN state — never a fabricated beginner / Building foundations / active Core Progression. Browsing the
// skill tree is unaffected; a browsed node is not Motus claiming it is the student's demonstrated skill.
const UNKNOWN_LEVEL = 'Not established';
const UNKNOWN_SKILL = 'Not established';
const NO_NEXT_SKILL = 'No recommendation yet';
const UNKNOWN_TRACK = 'Not established';

export function getProgressionRecommendationDisplay(summary = {}) {
  const hasRecommendation =
    summary?.hasProgressionEvidence === true || summary?.progressionInput?.hasEvidence === true;

  const evidenceFocus =
    summary?.progressionRecommendation?.skillFocus || summary?.progressionInput?.skillFocus || '';

  const currentLevelDisplay = hasRecommendation
    ? (formatLevel(summary?.currentLevel) || UNKNOWN_LEVEL)
    : UNKNOWN_LEVEL;
  const currentSkillName =
    summary?.currentSkill?.name || (hasRecommendation && evidenceFocus ? evidenceFocus : UNKNOWN_SKILL);
  const nextSkillName = summary?.nextSkill?.name || NO_NEXT_SKILL;
  const trackName = summary?.activeTrack?.name || UNKNOWN_TRACK;
  const reasonText = hasRecommendation ? (summary?.recommendationReason || '') : '';
  const lessonFlowStages = (summary?.lessonFlowStages || []).map(buildStageDisplay);
  const lessonFlowSkillName = summary?.nextSkill?.name || summary?.currentSkill?.name || currentSkillName;

  return {
    hasRecommendation,
    // both canonical evidence sources are named — Pass 77 supports lesson-only progression, not reviews only.
    emptyStateText:
      'Your progression recommendation will appear once you have reviewed sessions or completed lessons to build from.',
    introText:
      'A first MVP recommendation built from your demonstrated level, recent coaching themes, and active skill track.',
    cards: [
      { label: 'Current Level', value: currentLevelDisplay },
      { label: 'Current Skill', value: currentSkillName },
      { label: 'Next Skill', value: nextSkillName },
      { label: 'Track', value: trackName },
    ],
    reasonTitle: 'Why This Recommendation',
    reasonText,
    showReason: Boolean(reasonText),
    hasLessonFlow: hasRecommendation && Boolean(summary?.lessonFlow),
    lessonFlowTitle: `Lesson flow for ${lessonFlowSkillName}`,
    lessonFlowStages,
    lessonFlowEmptyText: 'A staged lesson flow will appear here as more skill lessons are added.',
  };
}
